var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"a-icon",attrs:{"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M2 2l8.485 8.486M10.485 2L2 10.486","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }